export function detectBrowserLanguage() {
  const language = (navigator.language || navigator.languages?.[0] || "").toLowerCase();
  if (language.startsWith("en")) return "en";
  if (language.startsWith("fr")) return "fr";
  return "fr";
}
